<div class="wrapper">    
    <div class="list">
        <div class="row row-start back-white-color">
            <div class="column">   
                <p class="tipo-second-color bold">{{'SUPER-ADMIN.CONSENT-BY-SPECIALTY.DATA-DATE-ON' | translate}}</p>
                <input type="date" name="signatureDateStart" (debounceInput)="addFilter('signatureDate-start', signatureDateStart.value)" [appDebounceInput]="300" #signatureDateStart >
            </div>
    
            <div class="column">  
                <p class="tipo-second-color bold">{{'SUPER-ADMIN.CONSENT-BY-SPECIALTY.DATA-DATE-OFF' | translate}}</p>
                <input type="date" name="signatureDateEnd" (debounceInput)="addFilter('signatureDate-end', signatureDateEnd.value)" [appDebounceInput]="300" #signatureDateEnd >
            </div>          
            <div class="column">
                <div class="checkbox">
                    <p class="tipo-second-color bold label">{{"SUPER-ADMIN.SIGNS-BY-COMPANY.EXCLUDE-BIO-SIGNS" | translate}}</p>
                    <a (click)="checkedExcludeBio()" >
                        <span class="checked_label" [ngClass]="{'isCheckedExcludeBio':isCheckedExcludeBio}" ></span>
                    </a>                   
                 </div>
            </div>   
          
           
      </div>
        <h4 class="title tipo-second-color bold" id="title_table">{{'SUPER-ADMIN.SIGNS-BY-COMPANY.TITLE-SIGNS-BY-COMPANY' | translate}}</h4>
            
        
        <table class="table" aria-describedby="title_table">
            <thead class="tipo-second-color bold"> 
                <tr>
                    <th rowspan="2" class="company_name" >  
                        <div class="column">
                        <span>{{'SUPER-ADMIN.LIST-ADMINS.DATA-COMPANY' | translate}} </span> 
                        <input type="text" name="filterName" (debounceInput)="addFilter('businessName', filterName.value)" [appDebounceInput]="300" #filterName id="filterName" placeholder="{{'PRIVATE.PATIENT.LIST-PATIENTS.FILTER' | translate }}">
                        </div>             
                        
                    </th>                           
                    <th colspan="2" class="signs_cis"> {{'SUPER-ADMIN.SIGNS-BY-COMPANY.SIGNS-CIS' | translate}} </th>    
                    <th colspan="2" class="signs_rgpds"> {{'SUPER-ADMIN.SIGNS-BY-COMPANY.SIGNS-RGPDS' | translate}} </th>
                    <th colspan="2" class="signs_dds"> {{'SUPER-ADMIN.SIGNS-BY-COMPANY.SIGNS-DDS' | translate}} </th>
                     <th colspan="2" class="signs_total"> {{'SUPER-ADMIN.SIGNS-BY-COMPANY.SUPER-TOTAL-SIGNS' | translate}} </th>
                </tr>
                <tr>
                    <th scope="col" class="signs_cis_bio">
                        <div class="row row-center">
                            {{'SUPER-ADMIN.SIGNS-BY-COMPANY.BIO' | translate}}
                            <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('consentBio', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('consentBio', 'desc')"></fa-icon>
                            </div>
                        </div>
                    </th>
                    <th scope="col" class="signs_cis_remote">
                        <div class="row row-center">
                            {{'SUPER-ADMIN.SIGNS-BY-COMPANY.REMOTES' | translate}}
                             <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('consentRemote', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('consentRemote', 'desc')"></fa-icon>
                            </div>
                        </div>
                       
                    </th>  
                    <th scope="col" class="signs_rgpd_bio">
                        <div class="row row-center">
                             {{'SUPER-ADMIN.SIGNS-BY-COMPANY.BIO' | translate}}
                             <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('rgpdBio', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('rgpdBio', 'desc')"></fa-icon>
                            </div>
                        </div>
                       
                    </th>
                    <th scope="col" class="signs_rgpd_remote">
                         <div class="row row-center">
                            {{'SUPER-ADMIN.SIGNS-BY-COMPANY.REMOTES' | translate}}
                            <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('rgpdRemote', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('rgpdRemote', 'desc')"></fa-icon>
                            </div>
                        </div>    
                    </th>
                    <th scope="col" class="signs_dd_bio">
                        <div class="row row-center">
                             {{'SUPER-ADMIN.SIGNS-BY-COMPANY.BIO' | translate}}
                            <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('ddBio', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('ddBio', 'desc')"></fa-icon>
                            </div>
                        </div>
                           
                    </th>
                    <th scope="col" class="signs_dd_remote">
                        <div class="row row-center">
                            {{'SUPER-ADMIN.SIGNS-BY-COMPANY.REMOTES' | translate}}
                            <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('ddRemote', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('ddRemote', 'desc')"></fa-icon>
                            </div>
                        </div>    
                    </th>
                    <th scope="col" class="signs_total_bio">
                        <div class="row row-center">
                            {{'SUPER-ADMIN.SIGNS-BY-COMPANY.BIO' | translate}}
                            <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('countTotalBio', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('countTotalBio', 'desc')"></fa-icon>
                            </div>
                        </div>    
                    </th>
                    <th scope="col" class="signs_total_remote">
                        <div class="row row-center">
                            {{'SUPER-ADMIN.SIGNS-BY-COMPANY.REMOTES' | translate}}
                            <div class="column arrows">
                                <fa-icon [icon]="faCaretUp" class="icono fa-xl up" (click)="sortSignatures('countTotalRemote', 'asc')"></fa-icon>
                                <fa-icon [icon]="faCaretDown" class="icono fa-xl down" (click)="sortSignatures('countTotalRemote', 'desc')"></fa-icon>
                            </div>
                        </div>    
                    </th>
                </tr>
            </thead>            
            <tbody>                
                <tr *ngFor="let signature of signatures?.signedDocumentsByCompany">
                    <td class="company_name">{{signature.businessName}}</td>
                   
                     <td class="signs_cis_bio"> {{signature.consentBio }} </td> 
                     <td  class="signs_cis_remote"> {{signature.consentRemote }} </td>
                     <td class="signs_rgpd_bio"> {{signature.rgpdBio }} </td> 
                     <td  class="signs_rgpd_remote"> {{signature.rgpdRemote }} </td>
                     <td class="signs_dd_bio"> {{signature.ddBio }} </td> 
                     <td  class="signs_dd_remote"> {{signature.ddRemote }} </td>
                      <td class="signs_total_bio"> {{ signature.countTotalBio }}</td> 
                     <td  class="signs_total_remote"> {{ signature.countTotalRemote }} </td>
                   
                </tr>
                <tr class="total_signs">
                    <td class="company_name tipo-second-color bold">{{'SUPER-ADMIN.SIGNS-BY-COMPANY.SUPER-TOTAL-SIGNS' | translate}}</td>                   
                    <td class="signs_cis_bio tipo-second-color bold">{{signatures?.grandCountConsentsBio}}</td>
                    <td class="signs_cis_remote tipo-second-color bold">{{signatures?.grandCountConsentsRemote}}</td>
                    <td class="signs_rgpd_bio tipo-second-color bold">{{signatures?.grandCountRgpdBio}} </td>  
                    <td class="signs_rgpd_remote tipo-second-color bold">{{signatures?.grandCountRgpdBio}} </td>                 
                    <td class="signs_dd_bio tipo-second-color bold">{{signatures?.grandCountDdBio}}</td>
                    <td class="signs_dd_remote tipo-second-color bold">{{signatures?.grandCountDdRemote}}</td>                  
                    <td class="signs_total tipo-second-color bold" >{{signatures?.grandCountTotalBio}}</td>    
                     <td class="signs_total tipo-second-color bold" >{{signatures?.grandCountTotalRemote}}</td>    
                </tr>
            </tbody>
        </table>       
</div>    

